import {
    GlobalExportToCSV,
    GlobalExportToExcel,
    GlobalExportToJSON,
    GlobalExportToPDF,
    GlobalExportToWord,
} from "../../utilitaires/globalFunction";

// Export de tableaux vers plusieurs formats, réutilisable dans tout écran.
// Usage : exporterTableau(lignes, "excel", "Piste d'audit", "audit_actions");
export type FormatExport = "excel" | "pdf" | "csv" | "json" | "word";

export const FORMATS_EXPORT: { cle: FormatExport; label: string }[] = [
    { cle: "excel", label: "Excel" },
    { cle: "pdf", label: "PDF" },
    { cle: "csv", label: "CSV" },
    { cle: "json", label: "JSON" },
    { cle: "word", label: "Word" },
];

// lignes : objets dont les clés deviennent les en-têtes du fichier
export function exporterTableau(
    lignes: Record<string, unknown>[],
    format: FormatExport,
    titre: string,
    nomFichier: string
) {
    switch (format) {
        case "excel":
            return GlobalExportToExcel(lignes, titre, nomFichier);
        case "pdf":
            return GlobalExportToPDF(lignes, titre, nomFichier);
        case "csv":
            return GlobalExportToCSV(lignes, titre, nomFichier);
        case "json":
            return GlobalExportToJSON(lignes, titre, nomFichier);
        case "word":
            return GlobalExportToWord(lignes, titre, nomFichier);
    }
}
